<template>
  <div class="login">
    <v-card class="main-card">
      <v-card-title>
        <h2 style="color:darkgreen;">Login to OKAGA</h2>
      </v-card-title>


      <v-card-text>
        <v-form>
          <v-text-field label="Username" v-model="username">
            <template v-slot:prepend>
              <v-icon style="margin-right: 12px" class="mx-5">mdi-account-circle</v-icon>
            </template>
          </v-text-field>

          <v-text-field
              label="Password"
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              @keypress="processKey($event)">
            <template v-slot:prepend>
              <v-icon style="margin-right: 12px" class="mx-5">mdi-lock</v-icon>
            </template>
          </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-text v-if="isError()">
        <span class="error-message">Username and password do not match. Please try again..</span><br/><br/>
      </v-card-text>
      <v-card-text>
        <span class="label16">Forgot password?</span><br>
        <span class="txt12">
          Email to <b>OklahomaAsianGolfAssociation@gmail.com</b> or contact our President to reset
          your password. Otherwise contact any of our OKAGA officers as alternates to reset your password.
        </span>

      </v-card-text>
      <v-divider style="margin-top: 30px"></v-divider>

      <v-card-actions>
        <a @click="enroll()">Enroll As New Participant?</a>
        <v-spacer></v-spacer>
        <v-btn style="background-color:darkgreen;color:white;" @click="formSubmit()">Login</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: "login",
    data: () => ({
      showPassword: false,
      username: '',
      password: ''
    }),
    methods: {
      isError() {
        const urlParams = new URLSearchParams(window.location.search);
        const error = urlParams.get('error')
        return (error !== null && error === 'true');
      },
      forgotPassword: function() {
        console.log('FORGOT PASSWORD');
      },
      loginSuccess() {
        this.loginStatus = 'SUCCESS';
        window.location.href = this.$AuthSvc.getLastUrl();
      },
      handleLogin(data) {
        console.log('LOGIN: ' + JSON.stringify(data));
        this.$AuthSvc.authenticated(this.loginSuccess);
      },
      processKey(event) {
        if (event.keyCode === 13) {
          this.formSubmit();
        }
      },
      enroll() {
        window.location.href = '/enroll';
      },
      formSubmit() {
        if (this.username !== '' && this.password !== '') {
          this.$AuthSvc.login(this.username, this.password, this.handleLogin);
        } else {
          window.location.href  = '/signin?error=true';
        }
      }
    }
  }
</script>

<style scoped>
  .v-card {
    background-color: (--back_ground);
  }

  .login {
    margin-top: 5px;
    width: 100%;
  }

  .login > .v-card {
    height: 400px;
    padding: 20px;
  }

  label {
    margin-left: 20px !important;
  }

  @media (min-width: 768px) {
    .login > .v-card {
      height: 400px;
      padding: 20px;
    }
  }

  .error-message {
    color: red;
    font-weight: bold;
    font-size: 18px;
  }

  a {
    color: darkblue;
    font-weight: bold;
  }

  a:hover {
    cursor: pointer;
  }

</style>